<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="auto">
        <base-material-snackbar
          v-model="snackbarShow"
          :timeout="$store.state.snackbar.timeout"
          type="success"
          top
          centered
        >
          {{ $store.state.snackbar.message }}
        </base-material-snackbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "DashboardCoreSnackBar",

  data() {
    return {
      snackbarShow: false,
    };
  },
  watch: {
    "$store.state.snackbar.show"() {
      this.snackbarShow = this.$store.state.snackbar.show;
    },
  },
};
</script>